/* Built In Imports */
import NextLink from 'next/link';
/* External Imports */
import { Box, Flex, Image, Link, Text } from '@chakra-ui/react';
import Slider from 'react-slick';
// import { LazyLoadComponent } from 'react-lazy-load-image-component';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import config from '@config';
import { refineUrlDomain } from '@components/Utility/utils';

/* Services */
/* Styles */
import { useState } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 * Renders VolunteerSharingTopSliderGroup Component
 *
 * @param {object} sectionContent - Data from api
 * @param {string} region - Region of page
 * @param {string} lang - Language of page
 * @returns
 */

const CSRTopSliderGroup = ({
  sectionContent,
  region,
  lang,
  formElement,
  background
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const [textIndex, setTextIndex] = useState(0);
  const styles = {
    default: 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
    'without-bottom-angle': '',
    '': 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
  };

  const handleButtonClick = (event) => {
    event.preventDefault();
    openModal();
  };

  const NextArrow = props => {
    const { onClick } = props;
    return (
      <Box
        pos="absolute"
        textAlign={'center'}
        top={{ base: '25%', md: '45%' }}
        zIndex="15"
        cursor="pointer"
        bgColor="#fff"
        border="0"
        borderRadius="32px"
        w="69.29px"
        h="53.21px"
        bgPos="center"
        bgRepeat="no-repeat"
        color="transparent"
        bgImage={`url(${config.staticPath}/d/46272/1711128888-chevron-right.svg)`}
        right={{ base: '2%', md: '84px' }}
        bgSize="22px"
        onClick={onClick}
        display={{ base: 'none', md: 'block' }}
      ></Box>
    );
  };

  const PrevArrow = props => {
    const { onClick } = props;
    return (
      <Box
        pos="absolute"
        top={{ base: '25%', md: '45%' }}
        zIndex="15"
        cursor="pointer"
        bgSize="22px"
        bgColor="#fff"
        border="0"
        borderRadius="32px"
        w="69.29px"
        h="53.21px"
        bgPos="center"
        bgRepeat="no-repeat"
        color="transparent"
        bgImage={`url(${config.staticPath}/d/46272/1711128885-chevron-left.svg)`}
        left={{ base: '10px', md: '84px' }}
        onClick={onClick}
        display={{ base: 'none', md: 'block' }}
      />
    );
  };

  const settings = {
    dots: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    infinite: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 834,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    beforeChange: (current, next) => setTextIndex(next),
    customPaging: function (i) {
      return (
        <Text
          cursor="pointer"
          display="inline-block"
          w="10px"
          h="10px"
          m="0px 8px"
          bgColor="#cf4520"
          borderRadius="50%"
        ></Text>
      );
    },
  };
  return (
    <>
      <Box
        pos={'relative'}
        className='bannerslider'
        height={{ base: '645px', md: '567px' }}
        mb="20px"
      >
        <Slider {...settings}>
          {sectionContent &&
            sectionContent?.slides?.length > 0 &&
            sectionContent?.slides?.map((slide, index) => {
              return (
                <Box height={'auto'} w={'100%'} pos="relative" key={index} background={{base:'linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 164.49%)', md:''}}>
                  <Box
                    h={{
                      base: "fit-content",
                      md: '567px',
                    }}
                    bgColor={{
                      base: '#000000;',
                    }}
                    backgroundRepeat="no-repeat"
                    backgroundSize="cover"
                    backgroundPosition={{
                      base: 'center',
                      sm: 'center',
                      lg: 'top center',
                      xl: '0',
                    }}
                    backgroundImage={{
                      md: slide?.desktopImage?.url,
                      base: slide?.mobileImage?.url || slide?.desktopImage?.url,
                    }}
                    mb={{ base: '0', xl: '0' }}
                    clipPath={styles[slide.style]}
                  >
                    {/* <NextLink href={refineUrlDomain(slide?.link, region, language )} passHref target='_blank'> */}
                    <Box
                      display={{
                        base: 'block',
                        sm: 'block',
                        md: 'block',
                        lg: 'none',
                        xl: 'none',
                      }}
                      flexDirection={'column'}
                      mt={{ base: '0', xl: '0' }}
                      p={['165px 15px 15px 15px', '24px', 4, 14]}
                      color={'#ffffff'}
                      lineHeight="1.11"
                      fontFamily="FedraSansStd-A-medium"
                      justifyContent={'center'}
                      maxH={'322px'}
                      alignItems={'center'}
                      background={background || `linear-gradient(360deg, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0) 255.5%)`}
                    >
                      <Box maxW="90%" textAlign={'center'} m="0 auto" >
                        <Box height={'65px'} display={'flex'} justifyContent={'center'} alignItems={'end'}>
                          <Box
                            as="h1"
                            pt={['0', '0px', '0', '0']}
                            fontFamily="FedraSerifAStdBook"
                            fontSize={{ base: '28px', md: '60px' }}
                            color="#FFA800"
                            fontWeight={'500'}
                            lineHeight="40px"
                            maxW={456}
                          >
                            {slide?.title}
                          </Box>
                        </Box>
                        <Box m="20px auto 0 auto" color={'#fff'} fontFamily="FedraSansStd-book" textAlign={'center'} fontSize={{ base: '16px' }}>{sectionContent?.slides[index]?.subTitle}</Box>
                      </Box>
                      <Box textAlign={'center'} m="0 auto" >
                        <Box maxW={'107px'} m={{base:'20px auto 0px auto', md:'10px auto 30px auto'}}>
                          <Image src={`${config.staticPath}/d/46272/1710820495-csr-white-headless-snake.png`} />
                        </Box>
                      </Box>
                    </Box>
                    {/* </NextLink> */}
                  </Box>

                  <Box background={'linear-gradient(360deg, #000000 84.26%, rgba(0, 0, 0, 0) 100%)'} minH={'195px'} display={{ base: 'block', md: 'none' }} w={{ base: '100%' }} p="16px" pt={'4rem'} m="0 auto" mt={'-3rem'} >
                    {sectionContent?.slides[index].shortBlurb && (
                      <Box
                        fontSize={{ base: '20px', md: '24px' }}
                        fontFamily="FedraSansStd-book"
                        textAlign="center"
                        fontWeight="bold"
                        color="#fff"
                        pt={['11px']}
                        lineHeight="20px"
                        textTransform="uppercase"
                      >
                        {sectionContent?.slides[index].shortBlurb}
                      </Box>
                    )}
                    {sectionContent?.slides[index].description && (
                      <Box
                        fontSize={{ base: '16px', md: '18px' }}
                        padding={{ base: '10px 0' }}
                        fontFamily="FedraSansStd-book"
                        color="#ffffff"
                        maxWidth="300px"
                        fontStyle="normal"
                        fontWeight="400"
                        lineHeight="23px"
                        maxW={'295px'}
                        margin="0 auto"
                        minH={'220px'}
                        textAlign={'center'}
                      >
                        {StructuredTextContent(
                          sectionContent?.slides[index].description
                        )}
                      </Box>
                    )}
                    <Box
                      placeItems="center"
                      h="50px"
                      w="100%"
                      m="20px auto 30px auto"
                      display={'flex'}
                      justifyContent={'center'}
                    >
                      <NextLink href={refineUrlDomain(sectionContent?.slides[index]?.cta.linkUrl, region, lang)} passHref target='_blank'>
                        <Link
                          m="16px 0 0 0"
                          color='#ffffff'
                          fontFamily='FedraSansStd-medium'
                          fontSize='20px'
                          fontStyle='normal'
                          fontbold='500'
                          lineHeight='24px'
                          minH={{ base: '48px', md: '50px' }}
                          padding={4}
                          width={{ base: '200px', md: '223px' }}
                          mb={'30px'}
                          display="block"
                          fontWeight={'500'}
                          bgColor={'rgb(207, 69, 32)'}
                          cursor={'pointer'}
                          textAlign={'center'}
                          borderRadius="5px"
                          textDecoration="none"
                          _hover={{
                            bg: 'rgb(255, 174, 39)',
                            color: '#28231E'
                          }}
                        >
                          {sectionContent?.slides[index].cta.buttonText}
                        </Link>
                      </NextLink>
                    </Box>
                  </Box>                
                </Box>
              );
            })}
        </Slider>
        
          <Box
            pos={{ base: 'absolute', md: 'absolute' }}
            top={{ base: '500px', md: '0' }}
            left="0"
            bottom={0}
            right={{ base: '0', md: '0' }}
            display={{ base: 'none', lg: 'block' }}
            background={{
              base: 'none',
            }}
            zIndex={10}
          >
            <Flex
              display={{
                base: 'flex',
                sm: 'flex',
                lg: 'flex',
              }}
              flexDirection={'column'}
              justifyContent={'center'}
              alignItems={'center'}
              h={{ base: '85%', md: '100%' }}
              mt={{ base: '0', xl: '0' }}
              p={['15px', '24px', '0px']}
              fontSize={{
                sm: '65px',
                base: '30px',
              }}
              color="#28231e"
              lineHeight="1.11"
              fontFamily="FedraSansStd-A-medium"
              background={background || 'linear-gradient(360deg, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0) 255.5%)'}
            >
              <Box width={{ base: '90%', md: '985px' }} mt={{base:'0', md:'115px'}}>
                <Box height={'auto'} display={'flex'} justifyContent={'center'} alignItems={'end'}>
                  <Box
                    as="h1"
                    pt={['0', '0', '0', '0']}
                    fontFamily="FedraSerifAStdBook"
                    fontSize={{ base: '28px', md: '60px' }}
                    mb="15px"
                    fontWeight={'500'}
                    textAlign={'center'}
                    color={'#FFA800'}
                  >
                    {sectionContent?.slides[textIndex]?.title}
                  </Box>
                </Box>
                <Box color={'#fff'} fontFamily="FedraSansStd-book" textAlign={'center'} fontSize={{ base: '16px', md: '28px' }}>{sectionContent?.slides[textIndex]?.subTitle}</Box>
              </Box>
              <Box display={'flex'} m={{base:'20px auto 30px auto', md:'10px auto 30px auto'}} justifyContent={'center'} textAlign={'center'}><Image src={`${config.staticPath}/d/46272/1710820495-csr-white-headless-snake.png`} /></Box>
              {sectionContent?.slides[textIndex].shortBlurb && (
                <Box
                  fontSize={{ base: '20px', md: '24px' }}
                  fontFamily="FedraSansStd-book"
                  textAlign="center"
                  fontWeight="bold"
                  color="#fff"
                  pt={['11px']}
                  lineHeight="20px"
                  textTransform="uppercase"
                >
                  {sectionContent?.slides[textIndex].shortBlurb}
                </Box>
              )}
              {sectionContent?.slides[textIndex].description && (
                <Box
                  fontSize={'16px'}
                  padding={{ base: '10px 0' }}
                  fontFamily="FedraSansStd-book"
                  color="#ffffff"
                  fontStyle="normal"
                  fontWeight="400"
                  textAlign={'center'}
                  maxW={{ base: '90%', md: '893px' }}
                  lineHeight="22px"
                  m={'10px auto 10px auto'}
                >
                  {StructuredTextContent(
                    sectionContent?.slides[textIndex].description
                  )}
                </Box>
              )}
              <Box
                placeItems="center"
                borderRadius="3px"
                h="50px"
                mb="20px"
              >
                <NextLink href={refineUrlDomain(sectionContent?.slides[textIndex]?.cta.linkUrl, region, lang )} passHref target='_blank'>
                <Link
                  m="16px 0 0 0"
                  color='#ffffff'
                  fontFamily='FedraSansStd-medium'
                  fontSize='20px'
                  fontStyle='normal'
                  fontbold='500'
                  // lineHeight='24px'
                  height={{base:'48px', md:'50px'}}
                  // padding={4}
                  padding="12px 0"
                  width={{ base: '200px', md: '223px' }}
                  mb={'30px'}
                  display="block"
                  fontWeight={'500'}
                  bgColor={'rgb(207, 69, 32)'}
                  cursor={'pointer'}
                  textAlign={'center'}
                  borderRadius="5px"
                  textDecoration="none"
                  _hover={{
                    bg: 'rgb(255, 174, 39)',
                    color: '#28231E'
                  }}
                >
                  {sectionContent?.slides[textIndex].cta.buttonText}
                </Link>
                </NextLink>
              </Box>
            </Flex>
          </Box>
          <style>
          {`
            .bannerslider .slick-dots {
              display: none !important;
            }
            @media (max-width: 768px) {
             .bannerslider .slick-slider {
                height: 318px;
             }
             .bannerslider .slick-dots {
                position: relative;
                display: block !important;
                bottom: 2.5rem;
              }
              .bannerslider .slick-dots li {
                width: 15px;
                height: 15px;
              }
              .bannerslider .slick-dots li p {
                background: #ffffff;
              }
              .bannerslider .slick-dots li.slick-active p {
                background: #CF4520;
              }
            }
          `}
        </style>
      </Box>
    </>
  );
};

export default CSRTopSliderGroup;